import { s as g } from "./es.string.replace-f4cc3aea.js";
import { t as v } from "./to-string-92a62764.js";
import { e as f } from "./export-cdcbfb2b.js";
import { i as l, c as u } from "./es.object.from-entries-0d7a0e54.js";
var S = g.charAt, c = v, o = f, I = l, i = u, s = "String Iterator", d = o.set, m = o.getterFor(s);
I(String, "String", function(e) {
  d(this, {
    type: s,
    string: c(e),
    index: 0
  });
}, function() {
  var t = m(this), n = t.string, a = t.index, r;
  return a >= n.length ? i(void 0, !0) : (r = S(n, a), t.index += r.length, i(r, !1));
});
